import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import LoadingModal from '../base/LoadingModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConnectInboxModalContainer = Loadable({
  LoadingComponent: props => /*#__PURE__*/_jsx(LoadingModal, Object.assign({}, props, {
    width: 700
  })),
  loader: () => import( /* webpackPrefetch: true, webpackChunkName: "ConnectInboxModalContainer" */'./ConnectInboxModalContainer')
});
export const ConnectYourInboxModalContainer = Loadable({
  LoadingComponent: props => /*#__PURE__*/_jsx(LoadingModal, Object.assign({}, props, {
    width: 700
  })),
  loader: () => import( /* webpackPrefetch: true, webpackChunkName: "ConnectInboxModalContainer" */'./ConnectYourInboxModalContainer')
});